<template lang="pug">
  .color-playground-modal
    try-it-on(:compareProductId="compareProductId" :view-on-model="modalProps.viewOnModel" @select="changeColor" @cancel="hideModal" data-mr-ass="change-color-modal")

</template>

<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    name: "ColorSelectPlaygroundModal",

    computed: {
      ...mapState('modal', ['modalProps']),

      viewOnModel() {
        return this.modalProps.viewOnModel;
      },

      compareProductId() {
        return this.modalProps.product ? this.modalProps.product.id : null;
      },
    },

    methods: {
      ...mapActions('colorAdvisor', ['persistCustomerAnswers']),
      ...mapActions('modal', ['hideModal']),

      changeColor(product) {
        this.persistCustomerAnswers({
          last_match_type: 'color_playground',
          want_code: product.code
        }).then(() => {
          this.hideModal();
          window.location.assign('/product/' + product.url_key);
        });
      }
    }
  }
</script>
